import {IframeModalShellComponent} from '@app/_components/iframe-modal-shell/iframe-modal-shell.component';
import {SbPremiumBadgeComponent} from '@app/_components/unified/sb-premium/sb-premium-badge.component';
import {SbPremiumLockComponent} from '@app/_components/unified/sb-premium/sb-premium-lock.component';
import {FileBrowserComponent} from '@app/_components/file-browser/file-browser.component';
import {SettingsService} from '@app/services/settings.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Injector, OnDestroy, OnInit, ChangeDetectionStrategy, inject, signal, viewChild } from '@angular/core';
import {
  WIDGET_HEADER_DESCRIPTIONS,
  WIDGET_HEADER_TEXT_EDITOR_CONFIG,
  WIDGET_TEXT_EDITOR_CONFIG,
  WidgetHeaderKey,
  widgetHeaderNotLiveNote,
  widgetHeaderPlaceholder
} from '@app/modules/shared/widget-text-editor-config';
import {SbRichTextComponent} from '@app/_components/unified/sb-rich-text/sb-rich-text.component';
import {GlobalWidgetService} from '@app/services/global-widget.service';
import {WidgetCustomizationAiModalComponent} from '@app/_components/widget-customization-ai/widget-customization-ai-modal.component';
import {WidgetCustomizationAiResult} from '@app/_components/widget-customization-ai/widget-customization-ai.types';
import {
  CampaignGetAll,
  getCampaignError,
  getCampaigns,
  getProject,
  getProjectError,
  getRegistrationPlatforms,
  getRegistrationPlatform,
  getVariableError,
  getVariables,
  getWidgetCustomScriptBody,
  ICampaignState,
  IProjectState,
  IRegistrationPlatformState,
  ITemplateState,
  IVariableState,
  ProjectGet,
  ProjectUpdate,
  RegistrationPlatformList,
  VariableList,
  WidgetCustomScriptBody,
  getLoggedInUser,
  IAuthenticationState,
  ITemplateSectionState,
  getToken,
  getRegistrationPlatformWidgetGuideUrl,
  RegistrationPlatformWidgetGuideURL,
  RegistrationPlatformDelete,
  RegistrationPlatformUpdate,
  RegistrationPlatformGet,
  getRegistrationPlatformSuccessResponse,
  getProjectSuccessResponse,
  getTemplateError,
  WidgetAvatarTemplateListAll,
  getWidgetAvatarTemplates
} from '@app/stores';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {select, Store} from '@ngrx/store';
import {filter, take, takeUntil, timeout} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {Campaign} from '@app/modules/shared/models';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {environment} from '@environments/environment';
import {Constants} from '@app/consts';
import {RegistrationPlatformService} from '@app/services/registration-platform.service';
import {AuthenticationService} from '@app/services/authentication.service';
import {EntityFormModalService} from '@app/_components/unified/entity-form-modal/entity-form-modal.service';
import Swal from 'sweetalert2';
import {WidgetAvatarTemplatesComponent} from '@app/modules/project/widget-avatar-templates/widget-avatar-templates.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import * as _ from 'lodash';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PageShellComponent } from '../../../_components/page-shell/page-shell.component';
import { SbInputFormComponent, SbInputFormActionsDirective } from '../../../_components/unified/sb-form/sb-form.component';
import { EntityLinkDirective } from '../../../_components/unified/entity-form-modal/entity-link.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';
import { SbInputLanguageComponent } from '../../../_components/unified/sb-select/sb-input-language.component';
import { SbInputSelectComponent } from '../../../_components/unified/sb-select/sb-select.component';
import { VariablesComponent } from '../../../_components/variables/variables.component';
import { FileBrowserComponent as FileBrowserComponent_1 } from '../../../_components/file-browser/file-browser.component';
import { SbRichTextComponent as SbRichTextComponent_1 } from '../../../_components/unified/sb-rich-text/sb-rich-text.component';
import { SbInputTextComponent } from '../../../_components/unified/sb-input/sb-input-text.component';
import { SbInputNumberComponent } from '../../../_components/unified/sb-input/sb-input-number.component';
import { SbInputColorComponent } from '../../../_components/unified/sb-input/sb-input-color.component';
import { SbCheckboxComponent } from '../../../_components/unified/sb-checkbox/sb-checkbox.component';
import { SbRadioComponent, SbRadioOption } from '../../../_components/unified/sb-radio/sb-radio.component';
import { SbTextareaComponent } from '../../../_components/unified/sb-textarea/sb-textarea.component';
import { SbCopyFieldComponent } from '../../../_components/unified/sb-copy-field/sb-copy-field.component';
import { SbTabsComponent } from '../../../_components/unified/sb-tabs/sb-tabs.component';
import { SbTabDirective } from '../../../_components/unified/sb-tabs/sb-tab.directive';
import { SbSelectItem } from '../../../_components/unified/sb-select/sb-select-base.component';
import { SbButtonComponent } from '../../../_components/unified/sb-button/sb-button.component';
import { AceEditorComponent } from '../../../_components/ace-editor/ace-editor.component';
import { IframeModalShellComponent as IframeModalShellComponent_1 } from '../../../_components/iframe-modal-shell/iframe-modal-shell.component';
import { SanitizeHtmlPipe } from '@app/_pipes';
import {SbModalService} from '@app/_components/unified/sb-modal/sb-modal.service';

const WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY = 'widget_media_advanced_defaults';
// How long the Widget Integration Assistant tab waits for the access token after a hard reload.
const INTEGRATION_ASSISTANT_TOKEN_WAIT_MS = 10000;

@Component({
  selector: 'app-widget-instructions',
  templateUrl: './widget-instructions.component.html',
  styleUrls: ['./widget-instructions.component.scss'],
  providers: [Constants],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageShellComponent, SbInputFormComponent, EntityLinkDirective, RouterLink, NgbPopover, ReactiveFormsModule, FormsModule, NgTemplateOutlet, SbInputLanguageComponent, SbInputSelectComponent, VariablesComponent, FileBrowserComponent_1, SbRichTextComponent_1, SbInputTextComponent, SbInputNumberComponent, SbInputColorComponent, SbCheckboxComponent, SbRadioComponent, SbTextareaComponent, SbCopyFieldComponent, SbTabsComponent, SbTabDirective, SbButtonComponent, AceEditorComponent, SbInputFormActionsDirective, IframeModalShellComponent_1, SanitizeHtmlPipe, SbPremiumBadgeComponent, SbPremiumLockComponent]
})
export class WidgetInstructionsComponent implements OnInit, OnDestroy, AfterViewInit {
  private route = inject(ActivatedRoute);
  private projectStore = inject<Store<IProjectState>>(Store);
  private campaignStore = inject<Store<ICampaignState>>(Store);
  private toastr = inject(ToastrService);
  constants = inject(Constants);
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private templateStore = inject<Store<ITemplateState>>(Store);
  private registrationPlatformService = inject(RegistrationPlatformService);
  private registrationPlatformStore = inject<Store<IRegistrationPlatformState>>(Store);
  private variableStore = inject<Store<IVariableState>>(Store);
  private readonly cdr = inject(ChangeDetectorRef);
  private elRef = inject(ElementRef);
  private _modalService = inject(NgbModal);
  private readonly sbModal = inject(SbModalService);
  private sanitizer = inject(DomSanitizer);
  private settingsService = inject(SettingsService);
  private readonly entityFormModal = inject(EntityFormModalService);
  private globalWidgetService = inject(GlobalWidgetService);
  private readonly injector = inject(Injector);

  // The code editor is in the Advanced tab, drawn only while that tab is open, so its settings go
  // with it rather than into ngAfterViewInit.
  aceEditorOptions: any = {maxLines: 1000, showLineNumbers: true, tabSize: 2};
  readonly displayModeOptions: SbSelectItem[] = [
    {id: 'popup', name: 'Popup'},
    {id: 'popup_minimized', name: 'Minimized Popup'},
    {id: 'embedded', name: 'Embedded'},
    {id: 'hidden', name: 'Hidden'},
  ];
  // The saved empty value is the default state; the select shows it as an option of its own.
  readonly defaultDisplayModeState = 'default';
  readonly displayModeStateOptions: SbSelectItem[] = [
    {id: this.defaultDisplayModeState, name: 'Default'},
    {id: 'minimized', name: 'Minimized'},
    {id: 'expanded', name: 'Expanded'},
  ];
  readonly linkedinShareMethodOptions: SbSelectItem[] = [
    {id: 'basic', name: 'Basic'},
    {id: 'authenticated', name: 'Authenticated'},
  ];
  readonly themeColorFields = [
    {key: 'theme_color_1', label: 'Default Texts Color', defaultValue: '#333399'},
    {key: 'theme_color_2', label: 'Background Color', defaultValue: '#FFFFFF'},
    {key: 'theme_color_3', label: 'Icons Color', defaultValue: '#333399'},
    {key: 'theme_color_4', label: 'Icons background color', defaultValue: '#e1e2e7'},
    {key: 'theme_color_5', label: 'Close Window Icon Color', defaultValue: '#8a8a8a'},
    {key: 'theme_color_6', label: 'Textarea Border color', defaultValue: '#cacaca'},
    {key: 'theme_color_7', label: 'Textarea text color', defaultValue: '#000000'},
    {key: 'theme_color_8', label: 'Textarea Background Color', defaultValue: '#ffffff'},
    {key: 'theme_color_9', label: 'Minimized Text Color', defaultValue: '#ffffff'},
    {key: 'theme_color_10', label: 'Minimized Background Color', defaultValue: '#333399'},
    {key: 'theme_color_11', label: 'Minimized Border Color', defaultValue: '#e1e2e7'},
  ];
  readonly videoModeOptions: SbRadioOption[] = [
    {value: 'auto', label: 'Auto'},
    {value: 'let_user_decide', label: 'Let user decide'},
    {value: 'disabled', label: 'Disabled'},
  ];
  readonly captionPositionOptions: SbRadioOption[] = [
    {value: 'top', label: 'Top'},
    {value: 'center', label: 'Middle'},
    {value: 'bottom', label: 'Bottom'},
  ];
  readonly widgetHeaderTextEditorConfig = WIDGET_HEADER_TEXT_EDITOR_CONFIG;
  readonly widgetHeaderDescriptions = WIDGET_HEADER_DESCRIPTIONS;
  readonly widgetTextEditorConfig = WIDGET_TEXT_EDITOR_CONFIG;
  globalWidget: any = null;
  readonly globalWidgetSettingKeys = [
    'active',
    'note',
    'whitelist_access',
    'auto_add_ip',
    'limit_access_ips',
    'language',
    'header_1',
    'header_2',
    'header_3',
    'promo_text',
    'open_message_text',
    'minimized_notification_message_disabled',
    'hide_when_closed',
    'minimized_notification_message',
    'user_agreement_checkbox_disabled',
    'show_preload',
    'display_mode',
    'display_mode_state',
    'linkedin_share_method',
    'tiktok_share_method',
    'theme_color_1',
    'theme_color_2',
    'theme_color_3',
    'theme_color_4',
    'theme_color_5',
    'theme_color_6',
    'theme_color_7',
    'theme_color_8',
    'theme_color_9',
    'theme_color_10',
    'theme_color_11',
    'font_face',
    'font_family',
    'font_by_language',
    'font_size',
    'show_widget_ui_customization_on_all_widgets',
    'enable_joined_influencer_cookie'
  ];
  projectMeta: any = {};
  project: any;
  variables = {};
  projectId;
  unsubscriber = new Subject();
  campaigns: Campaign[] = [];
  registrationPlatforms = [];
  // The custom script dialog is a view of its own, outside this one, and its body arrives after
  // it opens: a signal.
  public readonly widgetCustomScriptBody = signal<any>(undefined);
  readonly editor = viewChild<any>('editor');
  ipLimitUrl = '';
  shareWidgetLinkUrl = '';
  widgetIntegrationUrl: SafeResourceUrl;
  widgetCustomizationCode: any = null;
  widgetCustomizationCss: any = null;
  widgetIntegrationGuide: any = null;
  currentUser: any;
  token = null;
  platformName = '';
  projectPlatformId: number;
  selectedPlatform: any;
  isWidgetSave = false;
  isResetSelectPlatform = false;
  projectRegistrationPlatformId: number = null;
  private widgetGuideUrl: string;
  selectedcampaign: any;
  selectedWidgetSupport = null;
  selectedSyncSupport = null;
  widgetSupportValues = [{id: 'basic', name: 'Minimum (Clients might need help and it may not always work)'},
    {id: 'full', name: 'Full (Clients can easily add without any help and works but there are workarounds)'},
    {id: 'ultimate', name: 'Ultimate (Clients can easily add without any help and works reliably)'}];
  defaultAvatarImage = 'https://snoball-dev.s3-accelerate.amazonaws.com/TiqzVPzCFnIRK8XPXCXLo5MsAZPgub.png';
  widgetAIAvatarTemplates = [];
  selectedWidgetAIAvatarTemplate = null;

  widgetBehaviorToggles = [
    { key: 'discover_form_fields_detect_first_fields', default: true, label: 'Registration forms: stop after the first matched field per type (reduces duplicate picks on complex forms)' },
    { key: 'discover_payment_form_fields_detect_first_fields', default: true, label: 'Payment forms: stop after the first matched field per type' },
    { key: 'discover_promotion_form_fields_detect_first_fields', default: true, label: 'Promotion forms: stop after the first matched field per type' },
    { key: 'discover_form_fields_only_if_visible', default: false, label: 'Registration: only detect fields that are visible on the page' },
    { key: 'discover_payment_form_fields_only_if_visible', default: false, label: 'Payment: only detect visible fields' },
    { key: 'discover_promotion_form_fields_only_if_visible', default: false, label: 'Promotion: only detect visible fields' },
    { key: 'convert_name_to_first_name_last_name', default: true, label: 'When only a full name is found, split it into first and last before registering' },
    { key: 'show_widget_only_if_trigger_container_is_visible', default: true, label: 'Only show the widget after the trigger container element is visible' },
  ];

  default_custom_fields = [
    { key: 'custom_message', label: 'Influencer Custom Message', value: '', required: false },
    { key: 'custom_1', label: 'Custom 1', value: '', required: false },
    { key: 'custom_2', label: 'Custom 2', value: '', required: false },
    { key: 'custom_3', label: 'Custom 3', value: '', required: false },
    { key: 'custom_4', label: 'Custom 4', value: '', required: false },
    { key: 'custom_5', label: 'Custom 5', value: '', required: false },
    { key: 'custom_6', label: 'Custom 6', value: '', required: false },
    { key: 'custom_7', label: 'Custom 7', value: '', required: false },
    { key: 'custom_8', label: 'Custom 8', value: '', required: false },
    { key: 'custom_9', label: 'Custom 9', value: '', required: false },
    { key: 'custom_10', label: 'Custom 10', value: '', required: false },
  ];
  constructor() {
    this.authenticationStore.pipe(select(getToken))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(newToken => {
        if (newToken) {
          this.token = newToken;
        }
      });
    this.route.params.subscribe(params => {
      if (params.projectId) {
        this.projectId = +params.projectId;
        this.loadProject(this.projectId);
        this.cdr.markForCheck();
      }
    });
  }

  ngOnInit(): void {
    window.addEventListener('message', this.handleFontBrowserMessage);
    this.subscribeToStore();
    this.loadWidgetAdvancedDefaultSettings();
    this.campaignStore.dispatch(CampaignGetAll({filter: {project_id: this.projectId}}));
    // this.variableStore.dispatch(VariableList({params: {}}));
    this.fetchWidgetAITemplates();
    this.getAllRegistrationPlatforms();
    this.loadGlobalWidget();
    setTimeout(() => {
      this.setWidgetCode();
      this.cdr.markForCheck();
    }, 500);
  }

  // The page binds straight into projectMeta and other plain fields, changed in place all over
  // this class: each answer below marks the view for check.
  subscribeToStore() {
    this.widgetGuideUrl = null;
    this.authenticationStore.pipe(select(getLoggedInUser)).subscribe(user => {
      this.currentUser = user;
      this.cdr.markForCheck();
    }
    );
    this.campaignStore.pipe(select(getCampaignError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.campaignStore.pipe(select(getVariableError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });
    this.projectStore.pipe(select(getProjectError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.registrationPlatformStore.pipe(select(getRegistrationPlatform))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(registrationPlatform => {
        if (registrationPlatform) {
          this.getAllRegistrationPlatforms();
          if (registrationPlatform.widget_support) {
            this.projectMeta['platform_name_with_support'] = `${registrationPlatform.name} ${registrationPlatform.widget_support}`;
            this.projectMeta['registration_platform_id'] = registrationPlatform.id;
            this.selectedPlatform = registrationPlatform.id;
            this.setWidgetCode();
          }
          this.cdr.markForCheck();
        }
      });

    this.variableStore.pipe(select(getVariables))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(variables => {
        if (variables) {
          const result = [];
          Object.entries(variables).forEach(([key, value]) => {
            if (value.hasOwnProperty('group') && value['group']) {
              if (!result[value['group']]) {
                result[value['group']] = [];
              }
              result[value['group']].push({
                name: value['title'].replace(value['group'].toString().toLowerCase().trim(), ''),
                key: value['alias'] ? `#${value['alias']}#` : value['key'],
                valueType: value['valueType']
              });
            } else {
              if (!result['generic']) {
                result['generic'] = [];
              }
              result['generic'].push({
                name: value['title'],
                key: value['key'],
                valueType: value['valueType']
              });
            }
          });
          this.variables = result;
        }
      });

    this.campaignStore.pipe(select(getCampaigns))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(campaigns => {
        if (campaigns && campaigns.length > 0) {
          this.campaigns = campaigns;
          this.cdr.markForCheck();
        }
      });

    this.registrationPlatformStore.pipe(select(getRegistrationPlatforms))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(registrationPlatforms => {
        if (registrationPlatforms && registrationPlatforms.length > 0) {
          registrationPlatforms = JSON.parse(JSON.stringify(registrationPlatforms));
          this.registrationPlatforms = registrationPlatforms.map(platform => {
            const supportName = this.widgetSupportValues.filter(item => item.id === platform['widget_support']);
            platform['platform_name_with_support'] = `${platform['name']} ${supportName?.length ? ' : ' + supportName[0]['name'] : ''}`;
            return platform;
          });
          this.setWidgetCode();
          this.cdr.markForCheck();
        }
      });

    this.registrationPlatformStore.pipe(select(getProjectSuccessResponse))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(updateProject => {
        if (updateProject) {
          this.project = updateProject;
          // The saved platform is now the project's own. Which projects use a platform is derived
          // on the server; the catalogue's old project_id list is no longer read or kept here.
          if (this.selectedPlatform && Number(this.selectedPlatform) !== this.projectRegistrationPlatformId) {
            this.projectRegistrationPlatformId = Number(this.selectedPlatform);
          }
          this.cdr.markForCheck();
        }

      });

    this.projectStore.pipe(select(getProject))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(project => {
        if (project) {
          this.project = project;
          //console.log('--------project', project);
          this.ipLimitUrl = environment.frontUrl.replace('/#', '').replace(/\/+$/, '') + `/b/project/${this.project.code}/whitelist/auto_add_ip`;
          if (project.widget_settings) {
            this.projectMeta = (typeof project.widget_settings === 'string') ?
              JSON.parse(project.widget_settings) : _.cloneDeep(project.widget_settings);
            if(this.projectMeta['active'] && !this.projectMeta.hasOwnProperty('show_widget_ui_customization_on_all_widgets')) {
              this.projectMeta['show_widget_ui_customization_on_all_widgets'] = true;
            }
            if(!this.projectMeta.hasOwnProperty('language')) {
              this.projectMeta['language'] = 'en-us';
            }
            if (!this.projectMeta.hasOwnProperty('widget_version')) {
              this.projectMeta['widget_version'] = this.effectiveWidgetVersion;
            }
            for (const toggle of this.widgetBehaviorToggles) {
              if (!this.projectMeta.hasOwnProperty(toggle.key)) {
                this.projectMeta[toggle.key] = toggle.default;
              }
            }
            if (!this.projectMeta.hasOwnProperty('referral_append_query_string_to_all_links')) {
              this.projectMeta['referral_append_query_string_to_all_links'] = true;
            }
            if(!this.projectMeta.hasOwnProperty('widget_cdn_enabled')) {
              this.projectMeta['widget_cdn_enabled'] = false;
            }
            if (!['basic', 'authenticated'].includes(this.projectMeta['tiktok_share_method'])) {
              this.projectMeta['tiktok_share_method'] = 'basic';
            }
            this.projectMeta['registration_platform_default_custom_js'] = this.projectMeta['registration_platform_default_custom_js'] ?? false;
            this.projectMeta['registration_platform_default_custom_css'] = this.projectMeta['registration_platform_default_custom_css'] ?? false;
            this.projectPlatformId = this.projectMeta.hasOwnProperty('registration_platform_id') ? this.projectMeta['registration_platform_id'] : '';
            this.projectRegistrationPlatformId = this.projectPlatformId;
            this.selectedPlatform =  this.projectPlatformId ? this.projectPlatformId.toString() : '';

            if (!this.projectMeta.hasOwnProperty('custom_fields')) {
              this.projectMeta['custom_fields'] = JSON.parse(JSON.stringify(this.default_custom_fields));
            } else {
              const existingCustomFieldsMap = {};
              this.projectMeta['custom_fields'].forEach(field => {
                existingCustomFieldsMap[field.key] = field;
              });

              const normalizedCustomFields = this.default_custom_fields.map(defaultField => {
                if (existingCustomFieldsMap[defaultField.key]) {
                  return existingCustomFieldsMap[defaultField.key];
                }
                return JSON.parse(JSON.stringify(defaultField));
              });

              this.projectMeta['custom_fields'] = normalizedCustomFields;
            }

            if (!this.projectMeta.hasOwnProperty('allow_influencers_to_edit_primary_info')) {
              this.projectMeta['allow_influencers_to_edit_primary_info'] = false;
            }
            this.ensureWidgetAdvancedDefaults();
            if (!this.projectMeta.hasOwnProperty('allow_influencers_to_update_their_video_in_widget')) {
              this.projectMeta['allow_influencers_to_update_their_video_in_widget'] = false;
            }
            if (!Array.isArray(this.projectMeta['font_by_language'])) {
              this.projectMeta['font_by_language'] = [];
            }
            // A v1 project opened before the preserve-v1 sweep has reached it still holds
            // its source in the plain keys; stash it under _old here so the keyed editors
            // and the AI convert flow see the same code the widget serves.
            if (this.effectiveWidgetVersion === 'v1') {
              if (!this.projectMeta.hasOwnProperty('custom_script_old')) {
                this.projectMeta['custom_script_old'] = this.projectMeta['custom_script'] ?? null;
              }
              if (!this.projectMeta.hasOwnProperty('custom_css_old')) {
                this.projectMeta['custom_css_old'] = this.projectMeta['custom_css'] ?? null;
              }
            }
          } else {
            this.projectMeta = {
              active: false,
              enable_linkedin_integration_before_registration: false,
              language: 'en-us',
              header_1: '',
              header_2: '',
              header_3: '',
              custom_script: '',
              custom_css: '',
              widget_cdn_enabled: false,
              custom_fields: this.default_custom_fields,
              default_new_register_campaign_id: null,
              conditional_new_register_campaign_id: null,
              registration_platform_id: null,
              note: '',
              whitelist_access: false,
              auto_add_ip: false,
              limit_access_ips: '',
              referral_allowed_domains: '',
              remote_log_disabled: true,
              google_analytics_disabled: false,
              registration_platform_default_custom_css: true,
              registration_platform_default_custom_js: true,
              user_agreement_checkbox_disabled: false,
              show_preload: false,
              debug: false,
              allow_influencers_to_edit_primary_info: false,
              allow_influencers_to_update_their_video_in_widget: false,
              ...this.widgetAdvancedDefaults,
              font_by_language: [],
              discover_form_fields_detect_first_fields: true,
              discover_payment_form_fields_detect_first_fields: true,
              discover_promotion_form_fields_detect_first_fields: true,
              discover_form_fields_only_if_visible: false,
              discover_payment_form_fields_only_if_visible: false,
              discover_promotion_form_fields_only_if_visible: false,
              convert_name_to_first_name_last_name: true,
              show_widget_only_if_trigger_container_is_visible: true,
              referral_append_query_string_to_all_links: true,
            };
          }
          this.setWidgetCode();
          this.applyDefaultGlobalInheritance();
          this.refreshWidgetIntegrationUrl();

          if (this.project?.activation_ends_at && this.projectMeta['active']) {
            const currentDate = new Date();
            const activationEndDate = new Date(this.project.activation_ends_at);
            if (currentDate > activationEndDate) {
              this.toastr.warning('Project active time is expired and the widget as the result is no longer active.', 'Warning');
            }
          }
          this.cdr.markForCheck();
        }
      });

    this.templateStore.pipe(select(getTemplateError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.templateStore.pipe(select(getWidgetCustomScriptBody))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetCustomScriptBody => {
        if (widgetCustomScriptBody) {
          this.widgetCustomScriptBody.set(widgetCustomScriptBody);
        }
      });

    this.templateStore.pipe(select(getWidgetAvatarTemplates))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(widgetAvatarTemplates => {
        if (widgetAvatarTemplates && widgetAvatarTemplates.length > 0) {
          this.widgetAIAvatarTemplates = widgetAvatarTemplates.map((item) => ({
            ...item,
            selectedImageVariation: item.image_variations.find(image => image.isActive)
          }));

          this.selectedWidgetAIAvatarTemplate = (this.projectMeta.hasOwnProperty('widget_ai_avatar_template') && this.projectMeta['widget_ai_avatar_template']) ?
            this.widgetAIAvatarTemplates.find(item => item.id === this.projectMeta['widget_ai_avatar_template']) : null;
          this.cdr.markForCheck();
        }
      });

  }
  // templateSectionsubscribeStores()  {
  //   this.templateSectionStore.pipe(select(getTemplateSectionAssets))
  //     .pipe(takeUntil(this.unsubscriber))
  //     .subscribe(templateSectionAssets => {
  //       if (templateSectionAssets) {
  //         if (Object.keys(this.variables).length > 0) {
  //           this.enableEditor(templateSectionAssets.assets?.css);
  //         } else {
  //           setTimeout(() => {
  //             this.enableEditor(templateSectionAssets.assets?.css);
  //           }, 1000);
  //         }
  //       }
  //     });
  // }

  ngAfterViewInit() {
    const editor = this.editor();
    editor?.getEditor().setOptions({
      showLineNumbers: true,
      tabSize: 2
    });
    // this.templateSectionStore.dispatch(TemplateSectionGetAssets({params: {html_mode: 'editor'}}));
    this.cdr.detectChanges();
  }

  getAllRegistrationPlatforms() {
    const options = {widget_support: true};
    if (this.currentUser?.can('filter-platforms-by-project', 'project')) {
      options['project_id'] = this.projectId;
    }

    this.registrationPlatformStore.dispatch(RegistrationPlatformList({
      params: {
        options: JSON.stringify(options),
      }
    }));
  }

  get remoteLogEnabled(): boolean {
    return !this.projectMeta['remote_log_disabled'];
  }

  set remoteLogEnabled(value: boolean) {
    this.projectMeta['remote_log_disabled'] = !value;
  }

  changeCheckBox(event) {
    this.projectMeta['whitelist_access'] = event.target.checked;
  }

  updateValue(variable, textFor) {
    const value = this.projectMeta[textFor] || '';
    const varValue = variable.key;
    this.projectMeta[textFor] = `${value} ${varValue}`;
  }

  onFileBrowserFieldSelected(url: string | null, fieldKey: string) {
    this.projectMeta[fieldKey] = url ?? '';
  }

  private loadProject(id) {
    this.projectStore.dispatch(ProjectGet({projectId: id}));
  }

  loadGlobalWidget() {
    if (!this.projectId) {
      return;
    }
    this.globalWidgetService.getForProject(Number(this.projectId))
      .pipe(takeUntil(this.unsubscriber)).subscribe({
        next: (response) => {
          this.globalWidget = response.data || null;
          this.applyDefaultGlobalInheritance();
          this.refreshWidgetIntegrationUrl();
          this.cdr.markForCheck();
        },
        error: () => {
          this.globalWidget = null;
          this.cdr.markForCheck();
        }
      });
  }

  private applyDefaultGlobalInheritance(): void {
    if (this.globalWidget
      && !Object.prototype.hasOwnProperty.call(
        this.projectMeta,
        'global_widget_inherited_settings'
      )) {
      this.projectMeta['global_widget_inherited_settings'] = [
        ...this.globalWidgetSettingKeys
      ];
    }
  }

  isGlobalSettingInherited(key: string): boolean {
    return !!this.globalWidget && (this.projectMeta?.['global_widget_inherited_settings'] || []).includes(key);
  }

  toggleGlobalSetting(key: string, inherited: boolean) {
    const keys = new Set(this.projectMeta?.['global_widget_inherited_settings'] || []);
    if (inherited) {
      keys.add(key);
    } else {
      keys.delete(key);
    }
    this.projectMeta['global_widget_inherited_settings'] = Array.from(keys);
  }

  getGlobalWidgetValueLabel(key: string): string {
    const value = this.getGlobalWidgetValue(key);

    if (!this.globalWidget) {
      return 'Not set';
    }
    if (key === 'registration_platform_id') {
      const platform = this.globalWidget.registration_platform
        || this.registrationPlatforms.find((item) => Number(item.id) === Number(value));
      return platform?.name || (value ? `#${value}` : 'None');
    }
    if (typeof value === 'boolean') {
      return value ? 'ON' : 'OFF';
    }
    if (value === null || value === undefined || value === '') {
      return 'Not set';
    }
    if (Array.isArray(value)) {
      return value.length ? `${value.length} configured` : 'Not set';
    }
    if (typeof value === 'object') {
      return 'Configured';
    }

    const label = String(value).replace(/_/g, ' ');
    return label.length > 60 ? `${label.slice(0, 57)}...` : label;
  }

  // A header the project keeps empty with Use Global off does not take the global text.
  getWidgetHeaderPlaceholder(key: WidgetHeaderKey) {
    return widgetHeaderPlaceholder(key, this.isGlobalSettingInherited(key) ? this.getGlobalWidgetValue(key) : null);
  }

  getWidgetHeaderNotLiveNote(key: WidgetHeaderKey) {
    if (!this.isGlobalSettingInherited(key) || !this.projectMeta?.[key]) {
      return null;
    }
    return widgetHeaderNotLiveNote(key, this.getGlobalWidgetValue(key));
  }

  getGlobalWidgetValue(key: string): any {
    if (!this.globalWidget) {
      return null;
    }

    if (key === 'active' || key === 'registration_platform_id' || key === 'note') {
      return this.globalWidget[key];
    }

    let settings = this.globalWidget.widget_settings || {};
    if (typeof settings === 'string') {
      try {
        settings = JSON.parse(settings);
      } catch (e) {
        settings = {};
      }
    }
    return settings[key];
  }

  isGlobalWidgetRichTextValue(key: string): boolean {
    return ['header_1', 'header_2', 'header_3', 'promo_text'].includes(key);
  }

  hasGlobalWidgetRichTextValue(key: string): boolean {
    const value = this.getGlobalWidgetValue(key);
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  getGlobalWidgetFormattedValue(key: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(String(this.getGlobalWidgetValue(key) || ''));
  }

  shareWidgetPreview() {
    this.isWidgetSave = true;
    if (!this.projectMeta['default_new_register_campaign_id']) {
      this.toastr.warning('Please select a campaign', 'Warning');
      return;
    }
    if (!this.validateCustomCode()) {
      return;
    }
    if (!this.isGlobalSettingInherited('font_by_language') && this.hasDuplicateLanguageFonts()) {
      this.toastr.error('Each language can only have one font configuration.', 'Error');
      return;
    }
    this.projectMeta['global_widget_inherited_settings'] = (
      this.projectMeta['global_widget_inherited_settings'] || []
    ).filter((key) => this.globalWidgetSettingKeys.includes(key));
    let project = JSON.parse(JSON.stringify(this.project));
    if (this.projectMeta['registration_platform_id']  === null || this.projectMeta['registration_platform_id']  === '') {
      delete this.projectMeta.registration_platform_id;
    } else {
      this.isResetSelectPlatform = true;
    }

    project = {
      ...project,
      widget_settings: {...this.projectMeta}
    };
    this.projectStore.dispatch(ProjectUpdate({project, projectId: this.projectId}));
    this.projectPlatformId = this.projectMeta['registration_platform_id'];
  }

  validateCustomCode(): boolean {
    if (this.globalWidget) {
      return true;
    }
    const customScript = this.projectMeta[this.customScriptKey];
    if (customScript && typeof customScript === 'string' && customScript.trim()) {
      try {

        new Function(customScript);
      } catch (e) {
        this.toastr.error('Custom Script syntax error: ' + (e?.message || e), 'Error');
        return false;
      }
    }

    const customCss = this.projectMeta[this.customCssKey];
    if (customCss && typeof customCss === 'string' && customCss.trim()) {
      let depth = 0;
      for (const char of customCss) {
        if (char === '{') {
          depth++;
        } else if (char === '}') {
          depth--;
          if (depth < 0) {
            break;
          }
        }
      }
      if (depth !== 0) {
        this.toastr.error('Custom CSS syntax error: unbalanced braces', 'Error');
        return false;
      }
    }

    return true;
  }

  showWidgetInstructions(widgetInstructions) {
    const widgetActive = this.isGlobalSettingInherited('active')
      ? !!this.globalWidget?.active
      : this.projectMeta['active'] === true;
    if (widgetActive) {
      if (this.projectMeta['default_new_register_campaign_id']) {
        this.refreshWidgetIntegrationUrl();
        const modelRef = this._modalService.open(widgetInstructions, {
          centered: false,
          size: 'xl',
          keyboard: true
        });
        modelRef.result.then((result) => {
        }, (reason) => {
        });
        if (this.currentUser?.can('hide-platform-url', 'project')) {
          setTimeout(() => {
            document.getElementsByClassName('platform-url')[0]?.remove();
          }, 500);
        }
      } else {
        this.toastr.warning('The widget is active but the settings are incorrect', 'Warning');
      }
    } else {
      this.toastr.warning('The widget is not active', 'Warning');
    }
  }

  showAddPlatformPopup() {
    this.entityFormModal.open('/settings/registration-platform/add');
  }

  showCustomScriptInstructions(modal) {
    const modelRef = this._modalService.open(modal, {
      centered: false,
      size: 'xl',
      keyboard: true
    });
    modelRef.result.then((result) => {
    }, (reason) => {
    });
    this.templateStore.dispatch(WidgetCustomScriptBody({version: this.effectiveWidgetVersion}));
  }

  onSelectRegistrationPlatform(event) {
    this.projectMeta['registration_platform_id'] = event ? event.value : null;
    this.selectedPlatform = event ?  this.projectMeta['registration_platform_id'].toString() : '';
    this.setWidgetCode();
  }

  setWidgetCode() {
    const registrationPlatformId = Number(this.projectMeta['registration_platform_id']);
    if (registrationPlatformId) {
      this.registrationPlatforms.map((item) => {
        if (item.id === registrationPlatformId) {
          const oldSuffix = this.effectiveWidgetVersion === 'v1' ? '_old' : '';
          this.widgetCustomizationCode = item[`widget_customization_code${oldSuffix}`];
          this.widgetCustomizationCss = item[`widget_customization_css${oldSuffix}`];
          this.widgetIntegrationGuide = item.widget_integration_guide;
          this.platformName = item.name;
        }
      });
    }
  }

  previewWidget() {
    if (this.projectMeta['active']) {
      window.open(`/share/join/${this.project.code}`, '_blank');
    }
  }

  startWidgetIntegrationAssistantSession() {
    if (!this.projectMeta['active']) {
      return;
    }
    const code = this.project.code;
    const authenticationService = this.injector?.get(AuthenticationService, null);
    const token = authenticationService?.getAccessToken() || this.token;
    // The server takes the token from `appcontext` once, swaps it for its own cookie session and
    // redirects to the same page without it, as the font browser and Bull Board do.
    if (token) {
      window.open(this.widgetIntegrationAssistantUrl(code, token), '_blank', 'noopener');
      return;
    }
    // The access token is in memory only and absent until the session refresh answers on a hard
    // reload. Open the tab now, while the click still counts as the user's, so no popup blocker
    // stops it, and send it to the assistant once the token arrives.
    const tab = window.open('', '_blank');
    let sent = false;
    const giveUp = () => {
      tab?.close();
      this.toastr.error('Could not start the Widget Integration Assistant. Sign in again and retry.');
    };
    if (!tab || !authenticationService) {
      giveUp();
      return;
    }
    authenticationService.accessToken$.pipe(
      filter((value): value is string => Boolean(value)),
      take(1),
      timeout(INTEGRATION_ASSISTANT_TOKEN_WAIT_MS),
      takeUntil(this.unsubscriber)
    ).subscribe({
      next: (value) => {
        sent = true;
        tab.opener = null;
        tab.location.href = this.widgetIntegrationAssistantUrl(code, value);
      },
      error: giveUp,
      complete: () => {
        if (!sent) {
          giveUp();
        }
      }
    });
  }

  private widgetIntegrationAssistantUrl(code: string, token: string): string {
    const appContext = encodeURIComponent(JSON.stringify({token}));
    return `${environment.apiUrl}/share/start-integration-session/${encodeURIComponent(code)}?appcontext=${appContext}`;
  }

  onclickWidgetGuide() {
    const platformId = this.projectMeta['registration_platform_id'];
    this.registrationPlatformService.previewUrl(platformId).pipe(takeUntil(this.unsubscriber)).subscribe(response => {
      if (response['success']) {
        window.open(response['data'].url, '_blank');
      }
    });
  }

  showCustomizeAvatarTemplatePopup() {
    this.cdr.detectChanges();
    const data = {
      project_id: this.projectId
    };
    const modelRef = this.sbModal.openComponent(WidgetAvatarTemplatesComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    }, {data});
    modelRef.result.then((result) => {
    }, (reason) => {
      this.fetchWidgetAITemplates();
    });
  }

  fetchWidgetAITemplates() {
    const orderBy = {column: 'created_at', dir: 'desc'};
    const options = {orderBy};
    setTimeout(() => {
      this.templateStore.dispatch(WidgetAvatarTemplateListAll({
        params: {
          options: JSON.stringify(options),
          project_id: this.projectId,
        }
      }));
    }, 500);
  }

  selectWidgetAIAvatarTemplate(id) {
    this.projectMeta['widget_ai_avatar_template'] = id;
    this.selectedWidgetAIAvatarTemplate = this.widgetAIAvatarTemplates.find((item) => item.id === id) || null;
  }

  dropCustomField(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.projectMeta.custom_fields, event.previousIndex, event.currentIndex);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleFontBrowserMessage);
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }


  get languageFonts(): any[] {
    if (!Array.isArray(this.projectMeta?.['font_by_language'])) {
      this.projectMeta['font_by_language'] = [];
    }
    return this.projectMeta['font_by_language'];
  }

  addLanguageFont() {
    this.languageFonts.push({ language: null, font_family: '' });
  }

  removeLanguageFont(index: number) {
    this.languageFonts.splice(index, 1);
  }

  /** Languages already claimed by another row, so the picker can grey them out. */
  languageFontTakenBy(index: number): string[] {
    return this.languageFonts
      .filter((entry, i) => i !== index && entry?.language)
      .map((entry) => entry.language);
  }

  isDuplicateLanguageFont(index: number): boolean {
    const language = this.languageFonts[index]?.language;
    return !!language && this.languageFontTakenBy(index).includes(language);
  }


  hasDuplicateLanguageFonts(): boolean {
    return this.languageFonts.some((_, index) => this.isDuplicateLanguageFont(index));
  }

  getWidgetTextEditorConfig(key: string) {
    return ['header_1', 'header_2', 'header_3'].includes(key)
      ? this.widgetHeaderTextEditorConfig
      : this.widgetTextEditorConfig;
  }

  onWidgetTextEditorChange(key: string, value: string) {
    if (!this.projectMeta['active'] || this.isGlobalSettingInherited(key)) {
      return;
    }
    this.projectMeta[key] = value || '';
  }

  onWidgetTextEditorVariableClick(variable, key: string, editorComponent: SbRichTextComponent | null = null) {
    if (!this.projectMeta['active'] || this.isGlobalSettingInherited(key)) {
      return;
    }

    if (editorComponent) {
      editorComponent.insertText(variable.key);
      this.projectMeta[key] = editorComponent.currentHtml();
      return;
    }

    this.projectMeta[key] = `${this.projectMeta[key] || ''}${variable.key}`;
  }

  onWidgetTextEditorFileSelected(url: string | null, key: string) {
    if (!this.projectMeta['active'] || this.isGlobalSettingInherited(key)) {
      return;
    }
    this.projectMeta[key] = url ?? '';
  }


  private refreshWidgetIntegrationUrl(): void {
    if (!this.project?.code) {
      return;
    }
    // The server signs the link (widget_integration_instruction_url); the page by code alone is the
    // link from before the signing, for a server that doesn't send one yet.
    const baseUrl = environment.frontUrl.replace('/#', '').replace(/\/+$/, '');
    const url = new URL(
      this.project.widget_integration_instruction_url
        || `${baseUrl}/b/project/${this.project.code}/widget_integration_instruction`,
      window.location.origin
    );
    url.searchParams.set(
      'campaign_id',
      String(this.projectMeta?.['default_new_register_campaign_id'] || 0)
    );
    url.searchParams.set('platform_id', String(this.getInstructionPlatformId() || 0));
    this.shareWidgetLinkUrl = url.toString();
    this.widgetIntegrationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.shareWidgetLinkUrl
    );
    this.cdr.detectChanges();
  }



  private getInstructionPlatformId(): number | null {
    if (this.globalWidget) {
      return Number(this.globalWidget.registration_platform_id) || null;
    }
    return Number(this.projectMeta?.['registration_platform_id']) || null;
  }


  get effectiveWidgetVersion(): 'v1' | 'v2' {
    const projectVersion = this.projectMeta?.['widget_version'];
    if (projectVersion === 'v1' || projectVersion === 'v2') {
      return projectVersion;
    }
    const resolvedProjectVersion = this.project?.widget_version;
    if (resolvedProjectVersion === 'v1' || resolvedProjectVersion === 'v2') {
      return resolvedProjectVersion;
    }
    let clientSettings = this.project?.client?.client_settings || {};
    if (typeof clientSettings === 'string') {
      try {
        clientSettings = JSON.parse(clientSettings);
      } catch (e) {
        clientSettings = {};
      }
    }
    return clientSettings.widget_version === 'v2' ? 'v2' : 'v1';
  }

  get customScriptKey(): string {
    return this.effectiveWidgetVersion === 'v1' ? 'custom_script_old' : 'custom_script';
  }

  get customCssKey(): string {
    return this.effectiveWidgetVersion === 'v1' ? 'custom_css_old' : 'custom_css';
  }

  get hasLegacyWidgetCustomization(): boolean {
    return !!(
      String(this.projectMeta?.['custom_script_old'] || '').trim()
      || String(this.projectMeta?.['custom_css_old'] || '').trim()
    );
  }

  get canGenerateWidgetCustomization(): boolean {
    return !!this.currentUser?.can('generate-widget-customization', 'project');
  }

  openWidgetCustomizationAi(): void {
    if (!this.canGenerateWidgetCustomization) {
      return;
    }
    const modalRef = this.sbModal.openComponent(WidgetCustomizationAiModalComponent, {
      centered: false,
      size: 'xl',
      keyboard: false,
      backdrop: 'static'
    }, {
      projectId: Number(this.projectId),
      registrationPlatformId: this.projectMeta?.['registration_platform_id']
        ? Number(this.projectMeta['registration_platform_id'])
        : null,
      currentScript: this.projectMeta?.[this.customScriptKey] || '',
      currentCss: this.projectMeta?.[this.customCssKey] || '',
      hasLegacyCustomization: this.hasLegacyWidgetCustomization,
    });

    modalRef.result.then((result: WidgetCustomizationAiResult) => {
      const scriptKey = result.target_widget_version === 'v1'
        ? 'custom_script_old'
        : 'custom_script';
      const cssKey = result.target_widget_version === 'v1'
        ? 'custom_css_old'
        : 'custom_css';
      this.projectMeta[scriptKey] = result.custom_script;
      this.projectMeta[cssKey] = result.custom_css;
      this.cdr.markForCheck();
    }).catch(() => {});
  }


  readonly fontFileBrowser = viewChild<FileBrowserComponent>('fontFileBrowser');

  readonly fontBrowserShell = viewChild<IframeModalShellComponent>('fontBrowserShell');

  fontBrowserUrl: SafeResourceUrl | null = null;

  fontBrowserModalRef: NgbModalRef | null = null;

  activeVideoCaptionFontSettingsTarget: any = null;

  /**
   * Counts the caption font changes. The font is written into the settings object in place, from
   * the font browser's message, while the settings dialog (a view of its own, outside this one)
   * shows it; reading this count ties that dialog to it.
   */
  private readonly captionFontChanges = signal(0);

  widgetAdvancedDefaults = {
    widget_profile_picture_min_width: 0,
    widget_profile_picture_min_height: 10,
    widget_profile_video_enable_recorder: true,
    widget_profile_video_min_duration: 0,
    widget_profile_video_max_duration: 10,
    widget_profile_video_min_width: 0,
    widget_profile_video_min_height: 0,
    widget_profile_video_target_aspect_width: 0,
    widget_profile_video_target_aspect_height: 0,
    widget_profile_video_caption_mode: 'let_user_decide',
    widget_profile_video_caption_let_user_decide: true,
    widget_profile_video_caption_position: 'bottom',
    widget_profile_video_caption_background_enabled: true,
    widget_profile_video_caption_background_color: '#FFFFFF',
    widget_profile_video_caption_background_opacity: 50,
    widget_profile_video_caption_font_color: '#000000',
    widget_profile_video_caption_font_opacity: 50,
    widget_profile_video_caption_font_family: '',
    widget_profile_video_caption_font_face: '',
    widget_profile_video_caption_font_url: '',
    widget_profile_video_background_mode: 'let_user_decide',
    widget_profile_video_background_let_user_decide: true,
    widget_profile_video_background_color: '#FFFFFF',
    widget_profile_video_enable_teleprompter: true,
    widget_profile_video_teleprompter_speed: 500,
    widget_profile_video_teleprompter_question: ''
  };

  openVideoCaptionFontBrowser(settingsTarget: any, template: any) {
    this.activeVideoCaptionFontSettingsTarget = settingsTarget;
    const theme = document.body.classList.contains('dark-theme') ? 'dark' : 'light';
    const appContext = { token: this.token, projectId: this.projectId || null };
    const url = `${environment.apiUrl}/share/font-browser/show?appcontext=${encodeURIComponent(JSON.stringify(appContext))}&theme=${theme}&requireRemoteFont=true`;
    this.fontBrowserUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.fontBrowserModalRef = this._modalService.open(template, {
      centered: false,
      size: 'xl',
      keyboard: true,
      windowClass: 'widget-font-browser-modal'
    });
  }

  onFontBrowserFileSelected(url: string | null) {
    if (!url) {
      return;
    }

    const message = {
      origin: 'parent',
      action: 'fontFileSelected',
      url
    };
    const iframeWindow =
      this.fontBrowserShell()?.iframe()?.nativeElement?.contentWindow ||
      (document.querySelector('.widget-font-browser-modal iframe') as HTMLIFrameElement | null)?.contentWindow;
    iframeWindow?.postMessage(message, '*');
  }

  getVideoCaptionFontLabel(settingsTarget: any) {
    // Read, so the settings dialog showing it follows a font picked in the font browser.
    this.captionFontChanges();
    const savedName = settingsTarget?.['widget_profile_video_caption_font_family'];
    if (savedName) {
      return savedName;
    }

    return 'Default caption font';
  }

  clearVideoCaptionFont(settingsTarget: any) {
    settingsTarget['widget_profile_video_caption_font_family'] = '';
    settingsTarget['widget_profile_video_caption_font_face'] = '';
    settingsTarget['widget_profile_video_caption_font_url'] = '';
    this.captionFontChanges.update((count) => count + 1);
  }

  openWidgetAdvancedSettings(template: any) {
    this.settingsService.getSettingByKey(WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((response: any) => {
        this.applyWidgetAdvancedDefaultSettings(response?.data?.value);
        this.openWidgetAdvancedSettingsModal(template);
      }, () => {
        this.ensureWidgetAdvancedDefaults();
        this.openWidgetAdvancedSettingsModal(template);
      });
  }

  saveWidgetAdvancedSettings(modal: any) {
    this.ensureWidgetAdvancedDefaults();
    modal.close();
  }

  private loadWidgetAdvancedDefaultSettings() {
    this.settingsService.getSettingByKey(WIDGET_MEDIA_ADVANCED_DEFAULTS_SETTING_KEY)
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((response: any) => {
        this.applyWidgetAdvancedDefaultSettings(response?.data?.value);
        this.cdr.markForCheck();
      }, () => {});
  }

  private openWidgetAdvancedSettingsModal(template: any) {
    this._modalService.open(template, {
      centered: true,
      keyboard: true,
      scrollable: true,
      windowClass: 'widget-advanced-settings-window'
    });
  }

  private applyWidgetAdvancedDefaultSettings(value: any) {
    const defaults = this.flattenWidgetAdvancedDefaults(value);
    if (Object.keys(defaults).length > 0) {
      this.widgetAdvancedDefaults = {
        ...this.widgetAdvancedDefaults,
        ...defaults
      };
    }
    this.ensureWidgetAdvancedDefaults();
  }

  private flattenWidgetAdvancedDefaults(value: any) {
    if (!value) {
      return {};
    }

    let parsed = value;
    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        return {};
      }
    }

    return {
      ...(parsed.image || {}),
      ...(parsed.video || {})
    };
  }

  private ensureWidgetAdvancedDefaults() {
    if (!this.projectMeta) {
      this.projectMeta = {};
    }
    if (
      !Object.prototype.hasOwnProperty.call(this.projectMeta, 'widget_profile_picture_min_height') &&
      Object.prototype.hasOwnProperty.call(this.projectMeta, 'widget_profile_picture_max_height')
    ) {
      this.projectMeta['widget_profile_picture_min_height'] = this.projectMeta['widget_profile_picture_max_height'];
    }
    Object.keys(this.widgetAdvancedDefaults).forEach(key => {
      const defaultValue = this.widgetAdvancedDefaults[key as keyof typeof this.widgetAdvancedDefaults];
      if (!Object.prototype.hasOwnProperty.call(this.projectMeta, key)) {
        this.projectMeta[key] = defaultValue;
      }
    });
    delete this.projectMeta['widget_profile_picture_max_height'];
    if (
      !(Number(this.projectMeta['widget_profile_video_min_height']) > 0) &&
      Object.prototype.hasOwnProperty.call(this.projectMeta, 'widget_profile_video_max_height')
    ) {
      this.projectMeta['widget_profile_video_min_height'] = this.projectMeta['widget_profile_video_max_height'];
    }
    this.projectMeta['widget_profile_video_caption_mode'] = this.normalizeWidgetVideoMode(
      this.projectMeta['widget_profile_video_caption_mode'],
      this.projectMeta['widget_profile_video_caption_let_user_decide']
    );
    this.projectMeta['widget_profile_video_caption_position'] = this.normalizeWidgetCaptionPosition(
      this.projectMeta['widget_profile_video_caption_position']
    );
    this.projectMeta['widget_profile_video_caption_background_enabled'] = this.normalizeWidgetBoolean(
      this.projectMeta['widget_profile_video_caption_background_enabled']
    );
    this.projectMeta['widget_profile_video_background_mode'] = this.normalizeWidgetVideoMode(
      this.projectMeta['widget_profile_video_background_mode'],
      this.projectMeta['widget_profile_video_background_let_user_decide']
    );
    this.projectMeta['widget_profile_video_caption_let_user_decide'] = false;
    this.projectMeta['widget_profile_video_background_let_user_decide'] = false;
  }

  private handleFontBrowserMessage = (event: MessageEvent) => {
    const data = typeof event.data === 'string' ? this.tryParseMessageData(event.data) : event.data;
    if (!data || data.origin !== 'fontBrowser') {
      return;
    }

    if (data.action === 'fontSelected') {
      this.applyVideoCaptionFontSelection(data);
      this.fontBrowserModalRef?.close();
      this.fontBrowserModalRef = null;
      this.activeVideoCaptionFontSettingsTarget = null;
    } else if (data.action === 'openFileBrowser') {
      this.fontFileBrowser()?.openFileBrowser();
    }
    this.cdr.markForCheck();
  };

  private applyVideoCaptionFontSelection(data: any) {
    const fontName = `${data.fontFamily || ''}`.trim();
    const target = this.activeVideoCaptionFontSettingsTarget || this.projectMeta;
    if (!fontName || !target) {
      return;
    }

    const fontFace = `${data.fontFace || data.fontStyle || ''}`.trim();
    const fontUrl = this.getFontUrlFromFontFace(fontFace);
    if (fontFace && !fontUrl) {
      this.toastr.warning('This font is only available on your computer. Upload a woff/woff2 font or choose a web font so saved videos can render it.', 'Font not available for server render');
      return;
    }

    target['widget_profile_video_caption_font_family'] = fontName;
    target['widget_profile_video_caption_font_face'] = fontFace;
    target['widget_profile_video_caption_font_url'] = fontUrl;
    this.captionFontChanges.update((count) => count + 1);
  }

  private getFontUrlFromFontFace(fontFace: string) {
    const match = `${fontFace || ''}`.match(/url\((['"]?)(.*?)\1\)/i);
    return match?.[2] || '';
  }

  private tryParseMessageData(raw: string) {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  private normalizeWidgetVideoMode(value: any, letUserDecide: any) {
    if (letUserDecide === true || letUserDecide === 'true' || letUserDecide === 1 || letUserDecide === '1') {
      return 'let_user_decide';
    }

    const normalized = `${value || ''}`.toLowerCase();
    if (normalized === 'let_user_decide') {
      return 'let_user_decide';
    }
    if (['disabled', 'off', 'none', 'false'].includes(normalized)) {
      return 'disabled';
    }
    return 'auto';
  }

  private normalizeWidgetCaptionPosition(value: any) {
    const normalized = `${value || ''}`.toLowerCase();
    return ['top', 'center', 'bottom'].includes(normalized) ? normalized : 'bottom';
  }

  private normalizeWidgetBoolean(value: any) {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'number') {
      return value !== 0;
    }
    if (typeof value === 'string') {
      return ['true', '1', 'on', 'yes'].includes(value.trim().toLowerCase());
    }
    return !!value;
  }
}
